import { Cart } from '@features/sales/domain/entities/cart/cart.entity';
import {
  CartSplitPolicy,
  OrderDraft,
  OrderType,
  SplitConfiguration,
  SplitMode
} from '@features/sales/domain/models/order/order-split.model';

export class ByPercentageSplitPolicy implements CartSplitPolicy {
  supports(config: SplitConfiguration): boolean {
    return config.mode === SplitMode.BY_PERCENTAGE;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  partition(cart: Cart, _config: SplitConfiguration): OrderDraft[] {
    return [
      {
        type: OrderType.SALE,
        items: cart.toDTOs(),
      },
    ];
  }
}


